import React from 'react';
import { DashboardLayout } from 'src/skins/venus/components/layouts';
import { BuyMobileDataForm } from 'src/skins/venus/forms';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { VenusModal } from 'src/skins/venus/components/common';

const pageTitle = 'Buy Mobile Data';

const Wrapper = styled.div`
  section {
    margin: 1rem 0;
  }
`;

const BuyMobileData = () => {
  const history = useHistory();
  return (
    <DashboardLayout>
      <VenusModal isOpen={true} closeModal={() => history.goBack()} fullheight={true} backgroundPage="bills">
        <Wrapper>
          <h2>{pageTitle}</h2>

          <section>
            <BuyMobileDataForm />
          </section>
        </Wrapper>
      </VenusModal>
    </DashboardLayout>
  );
};

export default BuyMobileData;
